import { t } from "@lingui/macro";
import { LinearGradient } from "expo-linear-gradient";

import { Button } from "@whoosh/design-system/src/components/controls";
import {
  BasketballIcon,
  DiningIcon,
  FitnessIcon,
  GolfIcon,
  RacquetsIcon,
  SalonIcon,
  SpaIcon,
  CroquetIcon,
  BoatingIcon,
  CardRoomIcon,
  ClubIcon,
  BusinessIcon,
  AquaticsIcon,
  HockeyIcon,
  ShuffleboardIcon,
} from "@whoosh/design-system/src/components/icons_v2/department";
import { WhooshCrownIcon } from "@whoosh/design-system/src/components/icons_v2/general";
import { CautionMinorOutlineIcon } from "@whoosh/design-system/src/components/icons_v2/general";
import {
  Box,
  VStack,
  Text,
} from "@whoosh/design-system/src/components/primitive";

import { useOtaUpdateOverlayContext } from "../context/OtaUpdateOverlayContext";
import { AnimatedIconCycler } from "./AnimatedIconCycler";

export const OtaUpdateOverlay = () => {
  const { isChecking, message, outcome, retryCheckForUpdates } =
    useOtaUpdateOverlayContext();

  const showRetry = outcome === "no_update" || outcome === "error";

  return (
    <Box
      position="absolute"
      top={0}
      bottom={0}
      left={0}
      right={0}
      backgroundColor="surface-primary"
      justifyContent="center"
      alignItems="center"
      padding={8}
    >
      <LinearGradient
        // Background Linear Gradient
        colors={["#D3F0E5", "rgba(29, 170, 117, 0)"]}
        style={{
          position: "absolute",
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 0,
        }}
      />
      <VStack alignItems="center" gap={4}>
        <VStack alignItems="center" gap={2}>
          {isChecking ? (
            <>
              <AnimatedIconCycler
                width={100}
                height={100}
                icons={[
                  WhooshCrownIcon,
                  GolfIcon,
                  RacquetsIcon,
                  BasketballIcon,
                  SpaIcon,
                  SalonIcon,
                  DiningIcon,
                  FitnessIcon,
                  CroquetIcon,
                  BoatingIcon,
                  CardRoomIcon,
                  ClubIcon,
                  BusinessIcon,
                  AquaticsIcon,
                  HockeyIcon,
                  ShuffleboardIcon,
                ]}
                iconProps={{
                  width: 100,
                  height: 100,
                  color: "outline-primary",
                }}
                holdDurationMs={900}
                travelPx={10}
              />
              <Text variant="mainTitle3" textAlign="center">
                {t`Downloading Update`}
              </Text>
              <Box pt={4} maxWidth={250}>
                <Text textAlign="center">
                  {isChecking
                    ? t`Just hang tight for a moment and we'll be right back on course.`
                    : message ||
                      t`We couldn't find an update right now. Please try again.`}
                </Text>
              </Box>
            </>
          ) : (
            <>
              <CautionMinorOutlineIcon
                width={100}
                height={100}
                color="outline-primary"
              />
              <Text variant="mainTitle3" textAlign="center">
                {t`Whoops! Update Failed`}
              </Text>
              <Box pt={4} maxWidth={250}>
                <Text textAlign="center">
                  {message ||
                    t`We couldn't find an update right now. Please try again.`}
                </Text>
              </Box>
            </>
          )}
        </VStack>

        {showRetry && !isChecking ? (
          <Button
            variant="secondary"
            onPress={retryCheckForUpdates}
            accessibilityLabel={t`Try Again button`}
          >{t`Try Again`}</Button>
        ) : null}
      </VStack>
    </Box>
  );
};
